import React from 'react';
import { APPROVAL_STAGE_COLORS } from '../../../../../../../constants/radar';
import {
  RadioGroup,
  RadioOption,
  RadioInput,
  RadioLabel,
  RadioDot,
  StageArrow,
  Label,
  Field,
} from './styles';

const APPROVAL_STAGES = Object.keys(APPROVAL_STAGE_COLORS).map(stage => ({
  value: stage.charAt(0).toUpperCase() + stage.slice(1).toLowerCase(),
  color: APPROVAL_STAGE_COLORS[stage]
}));

const ApprovalStageSelector = ({ selectedStage, onStageChange }) => {
  const handleStageChange = (stageValue) => {
    // Toggle behavior - clicking selected stage deselects it
    onStageChange(selectedStage === stageValue ? '' : stageValue);
  };

  return (
    <Field>
      <Label>Approval Stage</Label>
      <RadioGroup>
        {APPROVAL_STAGES.map((stage, index) => (
          <React.Fragment key={stage.value}>
            <RadioOption>
              <RadioInput
                type="radio"
                id={`stage-${stage.value}`}
                name="approvalStage"
                value={stage.value}
                checked={selectedStage === stage.value}
                onChange={() => handleStageChange(stage.value)}
              />
              <RadioLabel
                htmlFor={`stage-${stage.value}`}
                checked={selectedStage === stage.value}
                onClick={(e) => {
                  e.preventDefault();
                  handleStageChange(stage.value);
                }}
              >
                <RadioDot color={stage.color} />
                {stage.value.charAt(0) + stage.value.slice(1).toLowerCase()}
              </RadioLabel>
              {index < APPROVAL_STAGES.length - 1 && <StageArrow />}
            </RadioOption>
          </React.Fragment>
        ))}
      </RadioGroup>
    </Field>
  );
};

export default ApprovalStageSelector;
